// extracted by mini-css-extract-plugin
export var IframeWrapper = "iframe-module--IframeWrapper--2na_k";
export var Iframe = "iframe-module--Iframe--17Hd6";